export default __webpack_public_path__ + "static/media/cs-a018-11.6cdfaaff.svg";